import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { useProductContext } from "~/domains/product/ProductContext";
import { Translation } from "~/app/i18n/Translation";
import { Link, type LinkProps, LinkType } from "~/common/components/Link";
import { useProductDetailsUrl } from "~/features/PackageRestriction/hooks/useProductDetailsUrl";
import type { ReactNode } from "react";
import classNames from "classnames";
import classes from "~/domains/product/components/ShortDescription.module.less";

interface Props extends BaseProductElementProps {
  as?: keyof JSX.IntrinsicElements;
  clickable?: boolean;
  linkProps?: LinkProps;
  truncate?: boolean;
}

export const ShortDescription = (props: Props) => {
  const { clickable = true, linkProps } = props;
  const product = useProductContext(props);
  const Cmp = props.as ?? "div";

  let href: string | undefined = useProductDetailsUrl(product);
  if (linkProps?.href) {
    href = linkProps.href;
  }

  let content: ReactNode = <Translation {...product.shortDescription} />;

  if (clickable && href) {
    content = (
      <Link href={href} variant={LinkType.SECONDARY} {...linkProps}>
        {content}
      </Link>
    );
  }

  return <Cmp className={classNames(props.className, props.truncate && classes.truncate)}>{content}</Cmp>;
};
